// --------------------------------------------------------
// CARE LINE OCCUPATIONAL HEALTH BOTTOM BUTTON AREA - CareLineOccupHealthBottomButtonArea
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React from 'react'
import Colors from '../../constants/Colors'
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
import { FooterButtonArea } from '../../pages/company/companyRegister/CompanyRegister.styled'
import { GenericSolidButton } from '../UI/buttons/Button.styled'
import CancelOrEditButton from '../UI/buttons/CancelOrEditButton'
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CARE LINE OCCUPATIONAL HEALTH BOTTOM BUTTON AREA INTERFACE
// --------------------------------------------------------

interface ICareLineOccupHealthBottomButtonArea{
    isConfirmationState: boolean;
    isFinalizarDisabled: boolean;
    isView: boolean;
    onEditClick: any;
    onCancelClick: any;
    onFinalizarClick: any;
    onVoltarClick: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CareLineOccupHealthBottomButtonArea = (
    {   isConfirmationState,
        isFinalizarDisabled,
        isView,
        onEditClick,
        onCancelClick,
        onFinalizarClick,
        onVoltarClick
    }:ICareLineOccupHealthBottomButtonArea) => {
  // --------------------------------------------------------
  // CARE LINE OCCUPATIONAL HEALTH BOTTOM BUTTON AREA PRIVATE DECLARATIONS
  // --------------------------------------------------------
    const { isMobile } = useResponsiveInfo()

  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
    {!isView ? 
        (<FooterButtonArea>
            <CancelOrEditButton
                style={{ marginBottom: isMobile ? 12 : 0 }}
                isEdit={isConfirmationState}
                onEditClick={onEditClick}
                onCancelClick={onCancelClick}
            />
            <GenericSolidButton
                color={Colors.SPM600}
                disabled={isFinalizarDisabled}
                type="submit"
                onClick={onFinalizarClick}
            >
                {isConfirmationState ? 'Finalizar cadastro' : 'Confirmar dados de cadastro'}
            </GenericSolidButton>
        </FooterButtonArea>)
        :
        (<FooterButtonArea>
            <GenericSolidButton
                onClick={onVoltarClick}
                color={Colors.SPM600}
                style={{ width: isMobile ? '100%' : '10%', marginBottom: isMobile ? 24 : 2 }}
            >
                Voltar
            </GenericSolidButton>
        </FooterButtonArea>
        )
    }
    </>
  )
  // --------------------------------------------------------
}

export default CareLineOccupHealthBottomButtonArea